import React from 'react';
import { CircleButton, Icon, LinkText } from '../../index';
import './link_list.scss';

export const LinkListItem = ({
    children,
    disabled = false,
    item,
    typographyType,
    typographyProps
}) => {

    const itemDisabled = disabled ? disabled : item.disabled;

    return (item &&
        <LinkText
            as={item.as}
            disabled={itemDisabled}
            display={item.display ? item.display : "block"}
            href={item.href}
            to={item.to}
            onClick={item.onClick}
            target={item.target}
            typographyType={typographyType ? typographyType : item.typographyType ? item.typographyType : 'body-02'}
            typographyProps={typographyProps || {}}
            type={item.type}
        >
            <div className="bsw-link-list__main">
                {item.icon && <div className="bsw-link-list__icon">
                    <Icon
                        disabled={itemDisabled}
                        name={item.icon || 'account'}
                        size="medium"
                    />
                </div>}
                <div className="bsw-link-list__content">
                    {children ? children : item.text}
                </div>
            </div>
            <div className="bsw-link-list__button">
                <CircleButton
                    icon={(item.icon || item.icon == '') ? item.icon : "arrow"}
                    disabled={itemDisabled}
                    colorStyle={item.colorStyle ? item.colorStyle : "float"}
                    as="div"
                />
            </div>
        </LinkText>
    );
};
